import React, { Fragment, useEffect, useState } from "react";
import Footer from "../component/Footer";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import axios from "axios";
import Modal from "../component/Modal";
import CTA from "../component/CTA";

export default function Success1() {
  const [review, setReview] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});
  const [type, setType] = useState("");
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    if (review.length === 0) {
      axios
        .get(`${process.env.REACT_APP_SERVER_ROUTE}/review`)
        .then((res) => {
          setReview(res.data);
          console.log(review);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  });

  return (
    <div>
      <div className=" py-24 sm:py-32">
        <div className="mx-auto max-w-screen-2xl px-6 lg:px-8">
          <div className="mx-auto max-w-7xl">
            <h2 className=" my-5 mx-auto max-w-max rounded-full bg-white px-5 py-1 text-center text-2xl font-extrabold  text-purple-500">
              Feedback
            </h2>
            <p className=" mx-auto max-w-5xl text-center   text-6xl font-extrabold   leading-tight tracking-tight text-gray-800 sm:text-7xl lg:max-w-xl 2xl:max-w-5xl 2xl:text-9xl">
              <span className="text-purple-500">ผลตอบรับ</span>
              หลังจากที่น้องๆ ได้เรียน
            </p>
          </div>
        </div>
        <div className="mt-24 gap-x-5 px-10  md:columns-2 lg:columns-3 2xl:columns-4">
          {review.map((student, idx) => (
            <div
              class="my-2 inline-block rounded-3xl bg-white p-10 text-left shadow-lg duration-200 ease-in-out hover:scale-105 hover:cursor-pointer "
              onClick={() => {
                setSelectedItem(student);
                setType("review");
                setOpenDialog(true);
              }}
              key={idx}
            >
              <div className="mb-7 flex flex-row">
                <img
                  src={`./img/student/${student.name}.jpg`}
                  className="h-16  w-16 rounded-full"
                />
                <div className="mx-5 items-center">
                  <h5 className="text-2xl font-medium">N' {student.name}</h5>
                  <p className="text-lg text-purple-500">{student.school}</p>
                </div>
              </div>
              <p className="lg:text-lg xl:text-xl">{student.description}</p>
            </div>
          ))}
          <Modal
            isOpen={openDialog}
            selectedItem={selectedItem}
            type={type}
            handleClose={() => {
              setOpenDialog(false);
              setSelectedItem({});
            }}
          />
        </div>
      </div>

      <div className="overflow-hidden bg-slate-100 py-24 sm:py-32">
        <div className="mx-auto max-w-screen-2xl px-6 lg:px-8">
          <h2 className=" my-2 mx-auto inline-block rounded-full bg-white px-5 py-1 text-2xl font-extrabold  text-purple-500">
            Success
          </h2>
          <p className="mt-2 max-w-3xl text-5xl font-extrabold leading-tight tracking-tight text-gray-800 sm:text-7xl md:max-w-xl 2xl:max-w-3xl 2xl:text-8xl">
            มาดูความสำเร็จของน้องๆ กัน
          </p>
          <OwlCarousel
            className="owl-theme teaching mx-auto mt-12  "
            margin={30}
            items={1}
            stagePadding={20}
            navText={[
              '<svg stroke="#000" fill="#000" stroke-width="0" viewBox="0 0 24 24" aria-hidden="true" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M11.03 3.97a.75.75 0 010 1.06l-6.22 6.22H21a.75.75 0 010 1.5H4.81l6.22 6.22a.75.75 0 11-1.06 1.06l-7.5-7.5a.75.75 0 010-1.06l7.5-7.5a.75.75 0 011.06 0z" clip-rule="evenodd"></path></svg>',
              '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24"  height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke="#000" stroke-width="2" d="M2,12 L22,12 M13,3 L22,12 L13,21"></path></svg>',
            ]}
            nav
            responsive={{
              640: {
                items: 2,
              },
              1024: {
                items: 3,
              },
            }}
          >
            {Array.from(Array(12), (e, i) => {
              return (
                <img
                  src={`./img/student/list/${i}.png`}
                  className="rounded-3xl shadow-sm"
                />
              );
            })}
          </OwlCarousel>
        </div>
      </div>
      <CTA />
      <Footer />
    </div>
  );
}
